import React from 'react';
import classNames from 'classnames';
import styles from './KeyValueCard.module.scss';
import Image from '../Image/Image';
import Icon from '../Icon/Icon';

export interface KeyValueCardProps {
  headline?: string;
  as?: keyof JSX.IntrinsicElements;
  className?: classNames.Argument;
  items: Array<{
    label: string;
    value: string;
    type: 'number' | 'text' | 'imageAndText';
    imgSrc?: string;
    alt?: string;
  }>;
}

const KeyValueCard: React.FC<KeyValueCardProps> = ({ headline, as: Tag = 'h3', className, items }) => {
  return (
    <div className={classNames(styles.root, className)}>
      {headline && <Tag className="typo-text-16--bold text-full">{headline}</Tag>}
      <dl className="flex flex-col gap-y-12">
        {items.map(({ label, value, type, imgSrc, alt }) => (
          <div key={label} className="flex justify-between items-center gap-16">
            <dt className="typo-text-14 w-full">{label}</dt>
            <dd className={`${type === 'imageAndText' ? 'flex items-center gap-6' : ''} text-faded w-full`}>
              {imgSrc && (
                <Image
                  className="w-[26px] h-[26px] rounded-full object-contain"
                  imageUrl={imgSrc}
                  alt={alt ?? ''}
                  fallbackComponent={<Icon name="package" width={20} height={20} />}
                />
              )}
              <span
                className={`${type === 'number' ? 'typo-mono status-neutral-1-surface p-4 rounded-sm' : 'block typo-text-14 truncate overflow-hidden text-ellipsis whitespace-nowrap max-w-[150px]'}`}>
                {value}
              </span>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default KeyValueCard;
